/*
 * Copyright (c) 2019.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Nikita Tropin <ntropin@yandex.ru>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import {MarketplaceFeature} from './MarketplaceFeature';
import {MarketplacePimFeature} from './MarketplacePimFeature';
import {MarketplaceMappingFeatureRelation} from './MarketplaceMappingFeatureRelation';
import {MarketplaceParameter} from "./MarketplaceParameter";
import {MarketplaceMappingParameterRelation} from "./MarketplaceMappingParameterRelation";

export interface MarketplaceMappingFeature {
  marketplaceFeatureList: MarketplaceFeature[];
  marketplacePimFeatureList: MarketplacePimFeature[];
  marketplaceFeatureMappingList: MarketplaceMappingFeatureRelation[];
  marketplaceParameterList: MarketplaceParameter[];
  marketplaceParameterMappingList: MarketplaceMappingParameterRelation[];
}
